import React from 'react';
import './Footer.css';
import logo from '../assets/images/logo.jpeg';
import { schoolInfo } from '../data/schoolData';

const navLinks = [
  { href: '#about', label: 'About Us' },
  { href: '#principal', label: "Principal's Message" },
  { href: '#gallery', label: 'Photo Gallery' },
  { href: '#facilities', label: 'Facilities' },
  { href: '#history', label: 'School History' },
  { href: '#contact', label: 'Contact Us' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="fb-logo"><img src={logo} alt="Logo" /></div>
            <div className="fb-name">{schoolInfo.name}</div>
            <p className="fb-desc">
              A minority institution committed to holistic education — nurturing minds,
              building character, and inspiring young lives in the heart of Guledgudd since 2011.
            </p>
            <div className="fb-motto">{schoolInfo.motto}</div>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>{navLinks.map(l => <li key={l.href}><a href={l.href}>{l.label}</a></li>)}</ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="#">{schoolInfo.address}</a></li>
              <li><a href="#">{schoolInfo.district} – {schoolInfo.pincode}, {schoolInfo.state}</a></li>
              <li><a href={`mailto:${schoolInfo.email}`}>{schoolInfo.email}</a></li>
              {schoolInfo.whatsapp && (
                <li>
                  <a href={`https://wa.me/91${schoolInfo.whatsapp}`} target="_blank" rel="noreferrer">
                    📱 +91 {schoolInfo.whatsapp}
                  </a>
                </li>
              )}
              <li><a href="#">DISE: {schoolInfo.dise}</a></li>
              <li><a href="#contact">Admissions 2026–27 Open</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p className='footer-copyright-txt'>© {new Date().getFullYear()} {schoolInfo.name}, Guledgudd. All rights reserved.</p>
          {/* <div className="footer-motto-txt">✝ {schoolInfo.tagline} · Est. {schoolInfo.founded}</div> */}
        </div>
      </div>
    </footer>
  );
}
